var map = {
	"./browser-notice.de-CH.json": 943,
	"./browser-notice.de-DE.json": 944,
	"./browser-notice.en-CA.json": 945,
	"./browser-notice.en-GB.json": 946,
	"./browser-notice.en-IN.json": 947,
	"./browser-notice.en-ME.json": 948,
	"./browser-notice.en-US.json": 949,
	"./browser-notice.es-EM.json": 950,
	"./browser-notice.es-ES.json": 951,
	"./browser-notice.fr-BE.json": 952,
	"./browser-notice.fr-CA.json": 953,
	"./browser-notice.fr-CH.json": 954,
	"./browser-notice.nl-BE.json": 955,
	"./browser-notice.nl-NL.json": 956,
	"./browser-notice.pl-PL.json": 957,
	"./browser-notice.pt-BR.json": 958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 942;